export default __webpack_public_path__ + "static/media/batteryPlugged.82e61afe.svg";